<template>
  <div class="gid-comment rounded-lg p-2">
    <div class="d-flex flex-row justify-content-between align-items-center">
      <span>{{ value.number }} - {{ value.title }} - {{ value.state }}</span>
      <!--commented part, will map values in furture-->
      <!-- <small class="text-muted">
        <BIconPeopleFill />
        {{ value.group.name }}
      </small> -->
    </div>
    <!-- <b-badge variant="primary">
      {{ value.state.name }}
    </b-badge> -->
    <div class="d-flex flex-row justify-content-between align-items-end mt-2">
      <!-- <div>
        <small>
          <span class="text-muted">From:</span>
          {{ value.creator.firstname }} {{ value.creator.lastname }}
        </small>
        <br />
        <small>
          <span class="text-muted">Owner:</span>
          {{ value.owner.firstname }} {{ value.owner.lastname }}
        </small>
      </div> -->
      <small class="d-flex flex-column align-items-end">
        <span class="text-muted">Updated:</span>
        {{ value.updatedAt | moment('lll') }}
      </small>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
// import { BIconPeopleFill } from 'bootstrap-vue';
import { RequestQueryBuilder, CondOperator } from '@dataui/crud-request';
import { TicketStatusEnum } from '@gid/models';
export async function fetchTickets({
  job: {
    job: { name: jobName },
  },
}) {
  const queryString = RequestQueryBuilder.create({
    filter: [
      {
        field: 'jobs.name',
        operator: CondOperator.EQUALS,
        value: jobName,
      },
      {
        field: 'status',
        operator: CondOperator.NOT_EQUALS,
        value: TicketStatusEnum.X,
      },
    ],
    sort: [{ field: 'messages.created_at', order: 'ASC' }],
  }).query();

  const tickets = await axios.get(`/data-api/ticket?${queryString}`);
  return tickets?.data?.map((ticket) => ({
    time: new Date(ticket.createdAt),
    value: {
      updatedAt: new Date(ticket.updatedAt),
      number: ticket.id,
      title: ticket.title,
      state: ticket.status,
    },
  }));
}

export default {
  components: {
    /**BIconPeopleFill */
  },
  props: {
    value: Object,
  },
};
</script>
